import React from 'react';
import { timeAgo } from '@/utils/ts/stringUtils';
import PackageIcon from '@mui/icons-material/Inventory2Outlined';

import AvatarComponent from '../AvatarComponent/AvatarComponent';

export default function PackagesNotification({ notification, handleNavigate }) {
  return (
    <div
      className={`single-notification ${notification.seen && 'seen'}`}
      onClick={handleNavigate}
      style={{ cursor: 'pointer' }}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <AvatarComponent
          src={notification?.influencerId?.profile_pic}
          alt={notification?.influencerId?.name || notification?.influencerId?.user_name}
        />
      </div>
      <div className="text-div">
        <h3 className="title">{notification.title}</h3>
        <p className="description">
          <PackageIcon />
          Your package to {notification?.influencerId?.first_name || '@' + notification?.influencerId?.user_name} was
          delivered.
        </p>
        <p className="timestamp" style={{ paddingTop: 8 }}>
          {timeAgo(notification?.createdAt)}
        </p>
      </div>
    </div>
  );
}
